import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initProductionHardening } from 'lib/production-hardening';
import { markIPhoneDocument } from 'lib/iphone';

markIPhoneDocument();
initProductionHardening();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
